import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const SystemSettingsFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {module, entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [unit, setUnit] = useState([]);
  const [vatRate, setVatRate] = useState([]);
  const [newFormData, setNewFormData] = useState({});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().systemSettingsId) || (entity === 'system-settings' && id)) {
      apiCall('patch', '/api/v2/network/settings/' + (window.App.urlVars().systemSettingsId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          // window.App.setState({rerenderSystemSettingsList: Math.random()})
          // if (props.goback === true) {
          //   history.push(props.backlink);
          // }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('patch', '/api/v2/network/settings', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          // window.App.setState({rerenderSystemSettingsList: Math.random()})
          // if (props.goback === true) {
          //   history.push(props.backlink);
          // } else {
          //   history.push('/system-settings/system-settings/update/' + response.data.data.id);
          // }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  const toolbarOptions = {
    container: [
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      ['image', 'formula'],
      [{'align': []}],

      [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
      [{'script': 'sub'}, {'script': 'super'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'color': []}, {'background': []}],
      ['clean']
    ]
  }

  useEffect(() => {
    apiCall('get', '/api/v2/network/settings')
      .then(response => {
        setFormData(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  useEffect(() => {
    // if ((!window.App.urlVars().create && window.App.urlVars().systemSettingsId) || (entity === 'system-settings' && id)) {
      setLoading(true);
      // apiCall('get', '/api/v2/system-settings/' + (window.App.urlVars().systemSettingsId ?? id))
      //   .then(response => {
      //     setFormData(response.data.data)
      //   })
      //   .catch(error => {
      //     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      //   })
      //   .finally(() => {
      //     setLoading(false);
      //   })
      apiCall('get', '/api/v2/unit')
        .then(response => {
          setUnit(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
      apiCall('get', '/api/v2/vat-rate')
        .then(response => {
          setVatRate(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    // }
  }, [])

  return (
    <div className={"system-settings-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="default_unit" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="default_unit"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldDefaultUnit')}</label>
                  <span className="p-d-block">
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    default_unit: e.value
                                  });
                                  setNewFormData({
                                    ...newFormData,
                                    default_unit: e.value
                                  });
                                  localStorage.setItem("defaultUnitId", e.value);
                                }}
                                value={formData?.default_unit?.id || formData?.default_unit || null}
                                options={unit}
                                optionLabel="name"
                                optionValue="id"
                                id={"unit"}
                                emptyMessage={"Még nincs egység..."}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="default_vat_rate" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="default_vat_rate"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldDefaultVatRate')}</label>
                  <span className="p-d-block">
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    default_vat_rate: e.value
                                  });
                                  setNewFormData({
                                    ...newFormData,
                                    default_vat_rate: e.value
                                  });
                                  localStorage.setItem("defaultVatRateId", e.value);
                                }}
                                value={formData?.default_vat_rate?.id || formData?.default_vat_rate || null}
                                options={vatRate}
                                optionLabel="label"
                                optionValue="id"
                                id={"vatRate"}
                                emptyMessage={"Még nincs ÁFA mérték..."}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(SystemSettingsFormComponent);
